export default class Model {
  /**
   * Model constructor
   *
   * @param {Object} model
   */
  constructor(model = {}) {
    this.model = model
  }

  getModel = () => {
    return this.model
  }
}
